import axiosInstance from "@/axios";

export const createNote = ({ profileId, proposalNumber, text }) => {
  return axiosInstance.post("/api/profile/notes", null, {
    params: {
      profileId,
      proposalNumber,
      text,
    },
  });
};

export const getNote = (profileId, proposalNumber) => {
  return axiosInstance.get(`/api/profile/notes/proposal/${proposalNumber}`, {
    params: {
      profileId,
    },
  });
};

export const updateNote = ({ profileId, proposalNumber, text }) => {
  return axiosInstance.patch(
    `/api/profile/notes/proposal/${proposalNumber}`,
    null,
    {
      params: {
        profileId,
        text,
      },
    },
  );
};

export const deleteNote = ({ profileId, proposalNumber }) => {
  return axiosInstance.delete(`/api/profile/notes/proposal/${proposalNumber}`, {
    params: {
      profileId,
    },
  });
};

export const getProfileNotes = (profileId) => {
  return axiosInstance.get(`/api/profile/notes/profile/${profileId}`);
};

export const updateNoteWindowSize = (
  tableSettingId,
  { noteWindowWidth, noteWindowHeight },
) => {
  return axiosInstance.patch(`/api/profile/tableSettings/${tableSettingId}`, {
    noteWindowWidth,
    noteWindowHeight,
  });
};
